import Characteristics from "./characteristics";
import CharacteristicsTitle from "./title";
import CharacteristicsItems from "./characteristic-items";

export default Characteristics;

export { CharacteristicsTitle, CharacteristicsItems };
